export default __webpack_public_path__ + "static/media/Davido-2.949efb2e.jpg";